<template functional>
  <div>
    <template
      v-if="
        props.row[props['column']].activity_values[0] &&
        !isNaN(Number(props.row[props['column']].activity_values[0].price))
      "
    >
      <format
        :value="
          Number(props.row[props['column']].activity_values[0].price) === 0 &&
          props.row['increment_rates'] &&
          props.row['increment_rates'][0] &&
          props.row['increment_rates'][0].rate_value
            ? props.row['increment_rates'][0].rate_value
            : props.row[props['column']].activity_values[0].price
        "
      />
    </template>
    <iconwarning v-else />
  </div>
</template>
<script>
export default {
  functional: true,
  name: 'UnitPriceErrorFormatter',
};
</script>
